module.exports = __webpack_public_path__ + "assets/img/btn-view-9e72afb9.png";